import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rr_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchProperties = (params = {}) =>
  api.get("/properties", { params }).then((r) => r.data);

export const fetchProperty = (id) =>
  api.get(`/properties/${id}`).then((r) => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const adminVerify = () => api.get("/admin/verify").then((r) => r.data);

export const uploadPhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload-photo", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data.photo);
};

export const createProperty = (data) =>
  api.post("/admin/properties", data).then((r) => r.data);

export const updateProperty = (id, data) =>
  api.put(`/admin/properties/${id}`, data).then((r) => r.data);

export const deleteProperty = (id) =>
  api.delete(`/admin/properties/${id}`).then((r) => r.data);

export const formatPrice = (value, currency = "MXN") => {
  if (value === null || value === undefined || Number(value) === 0) return "Precio a consultar";
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: currency || "MXN",
    maximumFractionDigits: 0,
  }).format(Number(value));
};
